import { FormControlLabel, styled, Switch } from '@mui/material';

import breakpoints from '../../../../constants/breakpoints';

export const Header = styled('header')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  paddingInline: 'var(--spacing-small)',
  [theme.breakpoints.down(breakpoints.desktopS)]: {
    justifyContent: 'space-between',
  },
}));

export const Label = styled(FormControlLabel)(({ checked }) => ({
  '& .MuiFormControlLabel-label': {
    color: 'var(--color-primary-lighter)',
    fontSize: 'var(--font-sm)',
    fontWeight: checked
      ? 'var(--font-weight-label-bold)'
      : 'var(--font-weight-button-label)',
  },
}));

export const StyledSwitch = styled(Switch)(() => ({
  '& .Mui-checked .MuiSwitch-thumb': {
    color: 'var(--color-primary-light)',
  },
  '& .Mui-checked ~ .MuiSwitch-track': {
    backgroundColor: 'var(--color-primary-lighter)',
    opacity: 1,
  },
  '& .MuiSwitch-thumb': {
    color: 'var(--color-grey-light)',
  },
}));
